
export enum PopupResults { Success = 1, Error, DeleteSuccess }

export class IPopupResult {
    result: PopupResults;
    messages: string[];
    id: number;
}